import type { DeepWritable, UUID } from '@cmg/common';
import { getDataSource } from '@cmg/data-grid';
import { useMemo } from 'react';

import type { FirmSalesCoverageGridItemFragment } from '../graphql/__generated__';
import { useFirmsSalesCoverageQuery } from './useFirmsSalesCoverageQuery';

export function useFirmsSalesCoverageGridDataSource({
  firmId,
  tenantId,
}: {
  firmId: string;
  tenantId?: UUID;
}) {
  const loadRows = useFirmsSalesCoverageQuery(tenantId);

  return useMemo(() => {
    return getDataSource({
      getData: async variables => {
        const { data, error } = await loadRows({
          ...variables,
          firmId,
        });
        if (error) {
          throw error;
        }
        return {
          rowData: (data?.investorFirmsGrid?.items?.[0]?.salesCoverage?.items ??
            []) as DeepWritable<FirmSalesCoverageGridItemFragment[]>,
          rowCount: data?.investorFirmsGrid?.items?.[0]?.salesCoverage?.totalCount ?? 0,
        };
      },
    });
  }, [loadRows, firmId]);
}
